<mat-sidenav-container fullscreen>
    <mat-sidenav-content>
        <app-backheader></app-backheader>
                <div class="col-center col s12 mt-12" style="margin-top: 6vh;margin-bottom:8vh">
            <div class="market-page-inne">
                <div class="row">
                    <div class="col-lg-8 mobp0">
                        <div class="main-match-detail">
                            <div class="sk_teambettingsection matchodds ng-star-inserted"
                                style="background: rgb(52, 52, 53);">
                                <div class="sk_bettinginner">
                                    <div class="sk_betting-con-wrap" style="position: unset;">
                                        <button type="button" class="sk_bettingbtnfull">
                                            <div class="sk_bettingtileleft">
                                                <div class="sk_bettingtileleft">
                                                    <div class="sk_betitle_div ng-star-inserted"><span
                                                            class="sk_betitle ng-star-inserted">{{ContestList.marketName}}</span><span
                                                            class="sk_bg-cross"></span></div>

                                                </div>

                                            </div>
                                            <span class="sk_matchedview">
                                                <div class="sk_matchedview-title ng-star-inserted">
                                                    <span>{{ContestList.openDate | date: 'dd/MM/yyyy'}}
                                                    </span>| <span>{{ContestList.openDate | date: 'hh:mm a'}}</span>
                                                </div>
                                            </span>
                                        </button>
                                        <div class="sk_match-detailtable" style="height: auto;">
                                            <div class="sk_match-detail-wrap">
                                                <div class="img-container">
                                                    <!-- <img src="../../assets/images/20210624176509.webp" alt=""
                                                        width="100%" height="100%"> -->
                                                    <img [src]="Base_Url+ContestList.image" alt="" width="100%"
                                                        height="100%">
                                                </div>
                                                <span class="remark">Q.{{ContestList.remark}}</span>
                                                <div class="sk_match-detail-body" style="padding: 5px 5px;"
                                                    *ngFor="let item of ContestList.runners; let i = index">
                                                    <div class="sk_match-detail-row grid-cols-12">

                                                        <div class="sk_match-body-col d-flex">
                                                            <span class="options">{{ getOptionLabel(i) }}.</span>
                                                            <div class="sk_match-teaminfo">
                                                                <div
                                                                    class="sk_match-teaminfo-inner d-flex align-items-center gap-2 relative">

                                                                    <input type="checkbox"
                                                                        style="opacity: 100;margin-left: 2px; ;"
                                                                        class="input"
                                                                        [checked]="selectedSelectionIds.includes(item.selectionId)"
                                                                        (change)="onRunnerSelect(item)"
                                                                        [disabled]="item.status === 'SUSPENDED'"
                                                                        id="runner{{ i }}" />

                                                                    <label for="runner{{ i }}"
                                                                        class="sk_match-team-name"
                                                                        style="margin-left:5px;">

                                                                        {{ item.runnerName }}  <span
                                                                            *ngIf="item.status === 'SUSPENDED'" style="color:darkred"> &nbsp;(Not
                                                                            Available)</span>
                                                                    </label>


                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="sk_match-body-col">
                                                    <div class="footer-c">
                                                        <div class="footer-c-text">
                                                            <span>Entry</span>:
                                                            <span>{{ContestList.entryPrice}}</span>
                                                        </div>
                                                        <div class="footer-c-text">
                                                            <span>Price</span>:
                                                            <span>{{ContestList.poolPrice}}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="place-btn-s">
                                                    <button class="place-btn" (click)="submitAnswer()">Place Bet</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="matchdetailsidebar">
                            <div class="sk_md-sidebar">
                                <div class="sk_widget">
                                    <div class="sk_open-bet">
                                        <div class="widgettitle">
                                            <h3 class="sk_opnbet-title">Open Bets</h3>
                                        </div>
                                        <div class="sk_open-bet-body">
                                            <div class="sk_open-bet-content">
                                            
                                                <div class="table-responsive openbet-table-wrap mt-2">
                                                    <table class="openbet-table table">
                                                        <thead>
                                                            <tr>
                                                                <th>Nation</th>
                                                                <th>Odds</th>
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="ng-star-inserted" *ngIf="BetList.length === 0">
                                                                <td colspan="6">
                                                                    <div class="nodata font-weight-bold">No Data
                                                                        Found!</div>
                                                                </td>
                                                            </tr>
                                                            <tr *ngFor="let item of BetList">
                                                                <td>{{item.eventName}}</td>
                                                                <td>{{item.selectionName}}</td>
                                                                <td>{{item.stake}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- betPlace_modal -->
            <div class="modal fade" id="betpopupmodal-modal" tabindex="-1" data-backdrop="static"
                aria-labelledby="betpopupmodalmodalLabel">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5>Bet Place</h5><a href="javascript:void(0)" class="modal-action modal-close"
                                aria-label="Close">
                                <i class="fas fa-times"></i>
                            </a>
                        </div>
                        <div class="modal-body">
                            <div class="teamtitle-pf">
                                <div class="match-title"><span></span> </div>
                                <div class="profit-loss">
                                    <span class="profit ml-5">


                                        <ng-container>

                                            <span class="ml-5" style="color: rgb(0, 100, 0);"> </span>


                                            <span style="float:right;" style="color: red"></span>
                                        </ng-container>

                                    </span>
                                </div>
                            </div>

                            <div class="betpace-box">
                                <div class="bet-collapse animated animatedfadeInDown fadeInDown mt-2p"
                                    style="display: flex;">
                                    <div class="bet-cont">
                                        <div class="bet-input-container">
                                            <form novalidate="" action=""
                                                class="form-inline ng-untouched ng-pristine ng-valid">
                                                <div class="row p-0 m-0 mb-10">
                                                    <div class="m-0 col s12 m12 xl12 d-inline-block left-align pr-5">
                                                        <div class="spin input-group">

                                                            <input type="number" placeholder="Rate"
                                                                ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/" min="0"
                                                                step="0.01" id="qytfild" maxlength="6"
                                                                class="form-control ng-untouched ng-pristine"
                                                                name="quant[2]" readonly>

                                                        </div>

                                                        <div class="spin input-group">

                                                            <input type="number" name="sst" min="0" pbautofocus=""
                                                                placeholder="Stake" id="qytfildone" pattern="[0-9]*"
                                                                step="1" placeholder="0" autocomplete="off"
                                                                class="form-control ng-pristine ng-valid ng-touched"
                                                                ng-reflect-pattern="[0-9]*" ng-reflect-model="0">

                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                                <div class="col s12 m12 xl12 bid-rate betslip-button">

                                                    <ng-container>
                                                        <a href="javascript:void(0)"></a>
                                                    </ng-container>

                                                    <a href="javascript:void(0)" class="clear-btn">Clear</a>
                                                </div>



                                                <div class="col s12 m12 xl12 bid-rate betslip-button">
                                                    <!-- Place Bet -->
                                                    <button class="btn btn-bet col s6">
                                                        <span class="animate-btn">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12"
                                                                height="12" viewBox="0 0 12 12">
                                                                <path id="Path_14" data-name="Path 14"
                                                                    d="M11.7,160.3,6.713,155.31a1.008,1.008,0,0,0-1.426,0L.3,160.3a1.008,1.008,0,0,0,0,1.426l4.992,4.992a1.008,1.008,0,0,0,1.426,0l4.992-4.992a1.008,1.008,0,0,0,0-1.426Zm-7.844,1.426a.5.5,0,1,1,0-.713A.5.5,0,0,1,3.861,161.728Zm.713-1.426a.5.5,0,1,1,.713,0A.5.5,0,0,1,4.574,160.3ZM6,163.867a.5.5,0,1,1,0-.713A.5.5,0,0,1,6,163.867Zm0-4.992a.5.5,0,1,1,.713,0A.5.5,0,0,1,6,158.876Zm1.426,3.565a.5.5,0,1,1,0-.713A.5.5,0,0,1,7.426,162.441Zm1.426-1.426a.5.5,0,1,1,0-.713A.5.5,0,0,1,8.852,161.015Z"
                                                                    transform="translate(0 -155.015)" fill="#fff">
                                                                </path>
                                                            </svg> Place Bet </span>
                                                    </button>

                                                    <button class="btn btn-bet col s6">
                                                        <span class="animate-btn">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12"
                                                                height="12" viewBox="0 0 12 12">
                                                                <path id="Path_14" data-name="Path 14"
                                                                    d="M11.7,160.3,6.713,155.31a1.008,1.008,0,0,0-1.426,0L.3,160.3a1.008,1.008,0,0,0,0,1.426l4.992,4.992a1.008,1.008,0,0,0,1.426,0l4.992-4.992a1.008,1.008,0,0,0,0-1.426Zm-7.844,1.426a.5.5,0,1,1,0-.713A.5.5,0,0,1,3.861,161.728Zm.713-1.426a.5.5,0,1,1,.713,0A.5.5,0,0,1,4.574,160.3ZM6,163.867a.5.5,0,1,1,0-.713A.5.5,0,0,1,6,163.867Zm0-4.992a.5.5,0,1,1,.713,0A.5.5,0,0,1,6,158.876Zm1.426,3.565a.5.5,0,1,1,0-.713A.5.5,0,0,1,7.426,162.441Zm1.426-1.426a.5.5,0,1,1,0-.713A.5.5,0,0,1,8.852,161.015Z"
                                                                    transform="translate(0 -155.015)" fill="#fff">
                                                                </path>
                                                            </svg> Place Bet</span>
                                                    </button>
                                                    <button class="btn btn-cancel z-depth-0 col s6">
                                                        <span class="animate-btn">
                                                            <i class="fas fa-times"></i> Cancel </span>
                                                    </button>
                                                </div>
                                                <div class="clearfix"></div>

                                            </form>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>